<template>
  <div style="background-color: white;">
    <v-btn color="primary" block @click="print()">печать</v-btn>
    <html id="printableArea" style="width:100%;overflow-y:visible">
      <head>
        <meta http-equiv="Content-Type" content="text/html; charset=utf-8"/>
        <link rel="stylesheet" href="print-report.css">
        <title>Печать отчета</title>
      </head>
      <body>
        <span v-html="report"></span>
      </body>
    </html>
  </div>
</template>

<script>
import pako from 'pako'
import { Base64 } from 'js-base64'
export default {
  name: 'PrintHtml',
  data: () => ({
    report: null
  }),
  methods: {
    print () {
      const printContents = document.getElementById('printableArea').innerHTML
      document.body.innerHTML = printContents
      setTimeout(() => { window.print() }, 1000)
    }
  },
  mounted () {
    const binaryArchived = Base64.decode(this.$route.query.data).split(',').map(x => parseInt(x))
    const inflated = new TextDecoder('utf-8').decode(pako.inflate(binaryArchived))
    this.report = inflated
  }
}
</script>

<style lang="css" scoped>
</style>
